module.exports = __webpack_public_path__ + "static/media/circle-checked.6dcee407.svg";